import React, { useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const navItems = [{
    name: t('nav.home'),
    href: '#hero'
  }, {
    name: t('nav.services'),
    href: '#services'
  }, {
    name: t('nav.portfolio'),
    href: '#portfolio'
  }, {
    name: t('nav.about'),
    href: '#about'
  }, {
    name: t('nav.booking'),
    href: '#contact'
  }, {
    name: t('nav.contacts'),
    href: '#contact'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 bg-[#FAFAF8]/98 backdrop-blur-sm transition-all duration-300 py-5 px-6 md:px-12 border-b border-[#1A1A1A]/8" data-id="element-127">
      <div className="max-w-[1920px] mx-auto flex justify-between items-center" data-id="element-128">
        {/* Logo */}
        <a href="#hero" className="flex items-center gap-4 group cursor-pointer" data-id="element-129">
          <div className="relative w-12 h-12 border border-[#B8956C] flex items-center justify-center transition-all duration-500 group-hover:border-[#1A1A1A]" data-id="element-130">
            <span className="font-serif text-2xl font-light tracking-tight" data-id="element-131">
              5П
            </span>
          </div>
          <div className="hidden md:block" data-id="element-132">
            <div className="font-serif text-xl tracking-wide font-medium" data-id="element-133">
              На 5 поверхів
            </div>
            <div className="text-[9px] tracking-[0.25em] uppercase opacity-50 font-light" data-id="element-134">
              Atelier
            </div>
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-12" data-id="element-135">
          {navItems.map(item => <a key={item.name} href={item.href} className="text-[11px] tracking-[0.2em] hover:text-[#B8956C] transition-colors uppercase font-light" data-id="element-136">
              {item.name}
            </a>)}
        </nav>

        {/* Language Switcher & Mobile Menu */}
        <div className="flex items-center gap-6" data-id="element-137">
          <button onClick={() => setLanguage(language === 'uk' ? 'ru' : 'uk')} className="flex items-center gap-2 text-xs tracking-wider hover:text-[#B8956C] transition-colors" data-id="element-138">
            <Globe size={16} strokeWidth={1.5} data-id="element-139" />
            <span className="uppercase font-light" data-id="element-140">{language}</span>
          </button>

          <button className="lg:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-141">
            {isMenuOpen ? <X size={24} strokeWidth={1.5} data-id="element-142" /> : <Menu size={24} strokeWidth={1.5} data-id="element-143" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Overlay */}
      {isMenuOpen && <div className="absolute top-full left-0 right-0 bg-[#FAFAF8] border-b border-[#1A1A1A]/8 p-8 lg:hidden flex flex-col items-center space-y-6 shadow-lg" data-id="element-144">
          {navItems.map(item => <a key={item.name} href={item.href} className="text-sm tracking-[0.2em] uppercase font-light" onClick={() => setIsMenuOpen(false)} data-id="element-145">
              {item.name}
            </a>)}
        </div>}
    </header>;
}